import React from 'react';
import PropTypes from 'prop-types';
import AngleDown from '../icons/AngleDown';
import UserHelper from '../../helpers/UserHelper';
import * as Roles from '../../resources/UserRole';
import { withCartConfig } from '../../hooks/CartConfigContext';
import { withStorefrontConfig } from '../../hooks/StorefrontSettingsContext';


const BranchSelection = (props) => {

    let isDisabled = props.isFetching || !UserHelper.hasRoles([Roles.CAN_SELECT_ORDERING_BRANCH], props.currentUser);
    return (
        <React.Fragment>
            <div className="fele-cart-freight-handling-codes" style={{ opacity: isDisabled ? .5 : 1 }}>
                <div className="label">
                    {props.localized.BranchSelection}
                </div>
                <div className="fele-content">
                    <div className="input-wrapper">
                        <div className="select-wrapper">
                            <select
                                disabled={isDisabled}
                                onChange={props.selectedBranchUpdate}
                                value={props.selectedBranch}
                            >
                                {props.branches &&
                                    props.branches.map((branch, index) => (
                                        <option
                                            key={index}
                                            value={branch.branchNumber}
                                        >
                                            {branch.branchName}
                                        </option>
                                    ))}
                            </select>
                            {!isDisabled && <AngleDown />}
                        </div>
                    </div>
                </div>
            </div>

        </React.Fragment>
    )
}

BranchSelection.propTypes = {
    currentUser: PropTypes.object,
    selectedCustomer: PropTypes.object
};

export default withStorefrontConfig(withCartConfig(BranchSelection));
